/*
 * @Descripttion:
 * @version:
 * @Author: limin
 * @Date: 2021-03-29 10:00:36
 * @LastEditors: limin
 * @LastEditTime: 2021-04-22 19:06:58
 */
import router from "./router";
import { keeps } from "./routes";
export const keepAlives = keeps;  //没用
export default router;
